import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, RotateCcw, ExternalLink } from "lucide-react";
import { RETURN_POLICY_META, RETURN_POLICY_SUMMARY, RETURN_POLICY_SECTIONS } from "@/lib/returnPolicy";

export function ReturnPolicyBody({ compact = false, testid = "return-policy-body" }) {
  return (
    <div className={`space-y-5 ${compact ? "text-xs" : "text-sm"} text-zinc-300 leading-relaxed`} data-testid={testid}>
      <div className="border border-lime-400/40 bg-lime-400/5 p-4">
        <div className="text-[10px] uppercase tracking-[0.25em] text-lime-400 font-black mb-2">At a glance</div>
        <ul className="space-y-1.5">
          {RETURN_POLICY_SUMMARY.map((s, i) => <li key={i} className="flex gap-2"><span className="text-lime-400">▸</span><span>{s}</span></li>)}
        </ul>
      </div>
      {RETURN_POLICY_SECTIONS.map((sec, i) => (
        <section key={i} data-testid={`${testid}-section-${i + 1}`}>
          <h3 className={`font-display font-bold uppercase text-white mb-1.5 ${compact ? "text-sm" : "text-base"}`}>{sec.h}</h3>
          {sec.p?.slice(0, sec.list ? 0 : undefined).map((t, j) => <p key={j} className="mb-2">{t}</p>)}
          {sec.list && <ul className="list-disc pl-5 space-y-1 mb-2">{sec.list.map((t, j) => <li key={j}>{t}</li>)}</ul>}
          {sec.list && sec.p?.map((t, j) => <p key={`p${j}`} className="mb-2">{t}</p>)}
        </section>
      ))}
      <p className="text-[11px] text-zinc-500">Effective {RETURN_POLICY_META.effective} · {RETURN_POLICY_META.company} · {RETURN_POLICY_META.contact} · {RETURN_POLICY_META.phone}</p>
    </div>
  );
}

export default function ReturnPolicyButton({ testid = "return-policy", light = false, className = "" }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={className} data-testid={`${testid}-wrap`}>
      <button type="button" data-testid={`${testid}-toggle`} onClick={() => setOpen(!open)} aria-expanded={open}
        className={`inline-flex items-center gap-2 border px-3 py-2 text-[10px] font-black uppercase tracking-widest transition-colors ${light ? "border-lime-400/60 text-lime-300 hover:bg-lime-400/10" : "border-pb-border text-zinc-300 hover:border-pb-red hover:text-white"}`}>
        <RotateCcw className="w-3.5 h-3.5" /> {RETURN_POLICY_META.windowDays}-Day Return Policy <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="mt-3 border border-zinc-800 bg-black/60 p-4 sm:p-5 max-h-[60vh] overflow-y-auto animate-fade-up" data-testid={`${testid}-panel`}>
          <div className="flex items-center justify-between gap-3 mb-4">
            <h2 className="font-display font-black uppercase text-lg text-white">Return, Refund & Exchange Policy</h2>
            <Link to="/return-policy" data-testid={`${testid}-full-link`} className="inline-flex items-center gap-1 text-[10px] uppercase tracking-widest text-lime-400 hover:text-white whitespace-nowrap">Full page <ExternalLink className="w-3 h-3" /></Link>
          </div>
          <ReturnPolicyBody compact testid={`${testid}-body`} />
        </div>
      )}
    </div>
  );
}
